/**
 * What the screen says between «принял» and the first byte of media.
 *
 * That gap used to be invisible: the phase is already `active`, the timer
 * reads 0:00 and nothing moves. It was a second long and nobody noticed. With
 * «сначала через релей» on it can be RELAY_GRACE_MS of silence plus a re-offer
 * — long enough for a person to hang up on a call that was about to connect —
 * so the wait has to look like work rather than like a hang.
 *
 * The phrases are what is actually happening, in order: the paths are being
 * gathered and tried (which *is* a search for the route), then the encoders
 * are being brought up under the negotiated caps. Time-based rather than
 * event-based because the events that would drive it — gathering complete,
 * the fallback re-offer — arrive at different moments on the two sides, and a
 * callee that waits on the caller's fallback has nothing of its own to show.
 * Pure so it can be tested without a DOM, like the rest of lib/.
 */
export function connectingStatus(elapsedMs: number): string {
  if (elapsedMs < 1500) return 'Соединение…';
  if (elapsedMs < 5000) return 'Ищу лучший маршрут для звонка…';
  if (elapsedMs < 9000) return 'Настраиваю качество…';
  return 'Ещё немного…';
}
